/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import FinReportsRoute from 'embercom/routes/apps/app/reports/customer-support/fin-ai-agent';
import { inject as service } from '@ember/service';
import Range from 'embercom/models/reporting/range';
import type Transition from '@ember/routing/transition';
import type ReportingService from 'embercom/services/reporting-service';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type ReportingViews from 'embercom/services/reporting-views';
import type RouterService from '@ember/routing/router-service';
import type Store from '@ember-data/store';
import { taskFor } from 'ember-concurrency-ts';
import { hash } from 'rsvp';
import ConversationAttributeDescriptor from 'embercom/models/conversation-attributes/descriptor';
import type CustomReportsService from 'embercom/services/custom-reports-service';

export default class FinStandaloneReportsOverviewRoute extends FinReportsRoute {
  controllerName = 'embercom/controllers/apps/app/reports';

  @service declare appService: AppService;
  @service declare reportingService: ReportingService;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare router: RouterService;
  @service declare reportingViews: ReportingViews;
  @service declare customReportsService: CustomReportsService;
  @service declare store: Store;

  queryParams = {
    rangeEnd: { refreshModel: true },
    rangeStart: { refreshModel: true },
  };

  // @ts-ignore
  async beforeModel(transition: Transition) {
    let defaultReport = this.reportingViews.standaloneDefaultReport;
    if (defaultReport) {
      await this.router.transitionTo('apps.app.standalone.reports.report.show', defaultReport.id);
    } else {
      let { rangeStart, rangeEnd } = transition.to.queryParams;
      let range = Range.createFromParams(rangeStart, rangeEnd, this.appService.app.timezone);
      this.reportingService.set('range', range);
      await Promise.all([
        taskFor(this.reportingMetrics.setup).perform(),
        this.customReportsService.preloadDescriptorsAndTicketTypes(),
      ]);
    }
  }

  async model() {
    let settings = this._fetchReportingSetting();
    let conversationAttributeDescriptors =
      await ConversationAttributeDescriptor.peekAllAndMaybeLoad();

    return hash({ conversationAttributeDescriptors, settings });
  }

  _fetchReportingSetting() {
    return (
      this.store.peekAll('reporting/settings')?.firstObject ||
      this.store.queryRecord('reporting/settings', {})
    );
  }
}
